import { gql } from '@apollo/client';
import { VersionHistoryFields } from 'ants/query';

export const TeamRankingReadQuery = gql`
  query TeamRankingReadQuery(
    $resource: TeamRankingInput!,
    $withHistory: Boolean
  ) {
    sports_cricket_team_ranking_read(
      resource: $resource,
      with_history: $withHistory
    ) {
      item {
      resource {
        account
        sport
        association
        gender
        format
        role
        key
       hashkey: _hashkey
      }
      ranks {
        team {
          account
          sport
          key
         hashkey: _hashkey
        }
        points
        ranking
        matches
        position
        changed_by
      }
      association
      name {
        name
      }
      updated_date {
        ranking_release_date
        ranking_recorded_date
        prev_ranking_release_date
        next_ranking_release_date
      }
    }
    history { 
      ${VersionHistoryFields}
    }
    }
  }
`;

export const RankingCreateMutation = gql`
  mutation RankingCreate(
    $association: AssociationInput!,
    $gender: SportsGender!,
    $format: CricketMatchFormat!,
    $role: CricketPlayerRole,
  ) {
    sports_cricket_team_ranking_create(
      association: $association,
      gender: $gender,
      format: $format,
      role: $role,
    ) {
      item {
      account
      sport
      association
      gender
      format
      role
      key
      _hashkey
    }
    status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
    is_similar_item
    }
  }
`;

export const TeamRankingCreateFromExistingMutation = gql`
  mutation TeamRankingCreateFromExistingMutation(
    $item: TeamRankingInput!
  ) {
    sports_cricket_team_ranking_create_from_existing(
      item: $item
    ){    
      item {
       account
       sport
       association
       gender
       format
       role
       key
       hashkey: _hashkey
     }
     status {
       okay
       errors {
         msg
         field_path
         code
       }
       key
     }
    }
  }
`;

export const TeamRankingSearchQuery = gql`
  query TeamRankingSearchQuery(
    $search: String!, 
    $page: PagedRequestInput
  ) {
    sports_cricket_team_ranking_search(
      search: $search,
      page: $page
    ) {
      items {
      item {
        account
        sport
        association
        gender
        format
        role
        key
        hashkey: _hashkey
      }
      association
      updated_date {
        ranking_release_date
        ranking_recorded_date
      }
    }
    page {
      next_page_key
      count
      prev_page_key
    }
    }
  }
`;

export const TeamRankingTopCountsQuery = gql`
  query TeamRankingTopCountsQuery(
    $search: String!, 
    $page: PagedRequestInput,
    $filters: RankingsFiltersInput
  ) {
    sports_cricket_team_ranking_search(
      search: $search,
      page: $page,
      filters: $filters
    ) {
      top_counts {
        genders {
          key
          name
          count
        }
        associations {
          key
          name
          count
        }
        formats {
          key
          name
          count
        } roles {
          key
          name
          count
        }
      }
    }
  }
`;

export const TeamRankingDeleteMutation = gql`
  mutation TeamRankingDeleteMutation(
    $resource: TeamRankingInput!
  ) {
    sports_cricket_team_ranking_delete (
      resource: $resource
    ) {
      status {
        okay
        errors {
          msg
          field_path
          code
        }
        key
      }
    }
  }
`;

export const TeamRankingUpdateMutation = gql`
  mutation TeamRankingUpdateMutation(
    $resource: TeamRankingInput!,
    $ranks: [TeamRankingTeamRankingInfoInput!]!,
    $updated_date: TeamRankingUpdatedDateInput!,
    $version: RecordStage
  ) {
    sports_cricket_team_ranking_update(
      resource: $resource,
      ranks: $ranks,
      updated_date: $updated_date,
      version: $version
    ) {
      status {
      okay
      errors {
        msg
        field_path
        code
      }
      key
    }
    }
  }
`;
